@use "../../styles/breakpoint.module.scss" as *;

.root {
    position: relative;
    margin: 0;
    padding-block: var(--spacer-56);

    &::before,
    &::after {
        content: "";
        height: 1px;
        background-color: var(--color-pale);
        position: absolute;
        width: 100%;
        left: 0;

        // A little hacky, however, we'd already sold out to both QuoteBlock
        // being 10-col AND BlockGroup having a single column width layout for
        // its contents, so this was the least intrusive workaround
        @media ($above-tablet) {
            width: calc(
                100% + var(--labui-grid-column-width) * 2 +
                    var(--labui-grid-gap) * 2
            );
            left: calc(
                var(--labui-grid-column-width) * -1 + var(--labui-grid-gap) * -1
            );
        }
    }

    &::before {
        top: 0;
    }

    &::after {
        bottom: 0;
    }
}

.quote {
    margin: 0;
    font: var(--font-h-40);

    &::before {
        content: "“";
    }

    &::after {
        content: "”";
    }
}

.citation {
    margin-top: var(--spacer-24);
    font: var(--font-s-18);
}
